<template>
  <yandex-map
    v-if="coords.length !== 0"
    :coords="coords"
    zoom="9"
    style="width: 100%; height: 600px"
    use-object-manager
    @map-was-initialized="initHandler"
  >
  </yandex-map>
</template>

<script>
import hardcodedPolygons from "@/assets/hardcodedPolygons.json";
import polygons2025 from "@/assets/polygons_2025.json";
import { yandexMap } from "vue-yandex-maps";
import axios from "axios";

function CustomSearchProvider(oms) {
  this.oms = oms;
}

CustomSearchProvider.prototype.geocode = function(request, options) {
  const deferred = new ymaps.vow.Deferred();
  const geoObjects = new ymaps.GeoObjectCollection();
  const offset = options.skip || 0;
  const limit = options.results || 20;
  let points = [];

  for (let i = 0, l = this.oms.length; i < l; i++) {
    const om = this.oms[i];
    om.objects.each(function(p) {
      if (
        p.properties.balloonContentHeader &&
        p.properties.balloonContentHeader.toLowerCase().includes(request.toLowerCase())
      ) {
        points.push(p);
      }
    });
  }

  points = points.slice(offset, offset + limit);

  points.forEach(point => {
    const coords = point.geometry.coordinates;
    const text = point.properties.hintContent;

    geoObjects.add(
      new ymaps.Placemark(coords, {
        name: text,
        balloonContentBody: text
      })
    );
  });

  deferred.resolve({
    geoObjects: geoObjects,
    metaData: {
      geocoder: {
        request: request,
        found: geoObjects.getLength(),
        results: limit,
        skip: offset
      }
    }
  });

  return deferred.promise();
};

export default {
  name: "RegionMap",
  components: { "yandex-map": yandexMap },
  props: {
    guest: Boolean,
    regionId: Number,
    activeYear: Number,
    municipalityName: String
  },
  data() {
    return {
      map: null,
      coords: [],
      points: [],
      hardcodedPolygons: hardcodedPolygons,
      polygons2025: polygons2025,
      objectManager: null,
      searchControl: null
    };
  },
  methods: {
    getMapInfo(year, regionId, guest) {
      axios
        .post("/eco-passport/get-map", { year, regionId, guest })
        .then(response => {
          this.coords = response.data.regionCenter || [];
          this.points = response.data.orgPoint || [];
        })
        .catch(() => {
        alert("Не удалось загрузить данные карты.");
      });
    },

    mapBalloon() {
      const balloons = {
        type: "FeatureCollection",
        features: []
      };

      this.points.forEach((point, index) => {
        if (!point.lat || !point.lng) {
          return;
        }

        const coords = [point.lat, point.lng];
        const header = point.rawHTMLHeader || "";
        const rawHTMLBody = point.rawHTMLBody || "";

        balloons.features.push({
          type: "Feature",
          id: index,
          geometry: { coordinates: coords, type: "Point" },
          properties: {
            balloonContentHeader: header,
            balloonContentBody: rawHTMLBody,
            clusterCaption: point.orgName || "",
            hintContent: point.orgName || ""
          },
          options: {
            iconColor: "#504FA0",
            balloonIconImageSize: 100
          },
          clusterName: "1"
        });
      });

      return balloons;
    },

    normalizeMunicipalityName(name) {
      if (typeof name !== 'string') {
        return '';
      }

      name = name.trim();

      if (name.startsWith("г.")) {
        return name.substring(2).trim();
      }

      if (name.startsWith("п.")) {
        return name.substring(2).trim();
      }

      if (name.startsWith("ЗАТО г.")) {
        return name.substring(7).trim();
      }

      if (name.startsWith("ЗАТО п.")) {
        return name.substring(7).trim();
      }

      return name;
    },

    normalizeNameForYandex(name) {
      if (typeof name !== 'string') {
        return '';
      }

      name = name.trim();

      if (name.startsWith("г.")) {
        return name.substring(2).trim();
      }

      if (name.startsWith("п.")) {
        return name.substring(2).trim(); 
      }

      if (name.startsWith("ЗАТО г.")) {
        return name.substring(7).trim(); 
      }

      if (name.startsWith("ЗАТО п.")) {
        return name.substring(7).trim(); 
      }

      if (name.endsWith("округ")) {
        if (!name.includes("муниципальный")) {
          return name.replace("округ", "муниципальный округ");
        }
      }

      if (name.endsWith("район")) {
        if (!name.includes("муниципальный")) {
          return name.replace("район", "муниципальный район");
        }
      }

      return name;
    },

    initHandler(map) {
      this.map = map;

      const municipalityName = this.municipalityName;
      const activeYear = this.activeYear;

      if (activeYear <= 2024) {
        const normalizedName = this.normalizeMunicipalityName(municipalityName);

        const result = this.hardcodedPolygons.find(item => 
          item.name && item.name.trim().toLowerCase() === normalizedName.trim().toLowerCase()
        );

        if (!result) {
          this.polygon = new ymaps.Placemark(this.coords, {
            hintContent: municipalityName
          }, {
            iconColor: '#9393f6',
            iconSize: [20, 20]
          });
          map.geoObjects.add(this.polygon);
        } else {
          const geojson = result.geojson;
          let coords = [];

          if (geojson.type === "Polygon") {
            coords = [geojson.coordinates[0].map(point => [point[1], point[0]])];
          } else if (geojson.type === "MultiPolygon") {
            coords = geojson.coordinates.map(part => part[0].map(point => [point[1], point[0]]));
          }

          this.polygon = new ymaps.Polygon(coords, {
            hintContent: municipalityName,
            balloonContent: `Границы ${municipalityName}`
          }, {
            fillColor: '#9393f6',
            fillOpacity: 0.3,
            strokeWidth: 2,
            strokeStyle: 'shortdash',
            strokeColor: '#9393f6'
          });

          map.geoObjects.add(this.polygon);
          map.setBounds(this.polygon.geometry.getBounds());
        }

      } else {
        // ЛОГИКА ДЛЯ ГОДА >= 2025
        const normalizedName = this.normalizeMunicipalityName(municipalityName);

        const result = this.polygons2025.find(item => 
          item.name && item.name.trim().toLowerCase() === normalizedName.trim().toLowerCase()
        );

        if (!result) {
          this.polygon = new ymaps.Placemark(this.coords, {
            hintContent: municipalityName
          }, {
            iconColor: '#9393f6',
            iconSize: [20, 20]
          });
          map.geoObjects.add(this.polygon);
        } else {
          const geojson = result.geojson;

          let coords = [];

          if (geojson.type === "GeometryCollection") {
            geojson.geometries.forEach((geometry) => {
              if (geometry.type === "Polygon") {
                coords.push(geometry.coordinates[0].map(point => [point[1], point[0]]));
              } else if (geometry.type === "MultiPolygon") {
                geometry.coordinates.forEach(part => {
                  coords.push(part[0].map(point => [point[1], point[0]]));
                });
              }
            });

          } else if (geojson.type === "Polygon") {
            coords = [geojson.coordinates[0].map(point => [point[1], point[0]])];

          } else if (geojson.type === "MultiPolygon") {
            coords = geojson.coordinates.map(part => part[0].map(point => [point[1], point[0]]));

          }

          this.polygon = new ymaps.Polygon(coords, {
            hintContent: municipalityName,
            balloonContent: `Границы ${municipalityName}`
          }, {
            fillColor: '#9393f6',
            fillOpacity: 0.3,
            strokeWidth: 2,
            strokeStyle: 'shortdash',
            strokeColor: '#9393f6'
          });

          map.geoObjects.add(this.polygon);
        }
      }

      if (!this.objectManager) {
        this.objectManager = new ymaps.ObjectManager({
          clusterize: true,
          clusterDisableClickZoom: true,
        });

        this.objectManager.clusters.options.set({
          clusterIconLayout: "default#pieChart",
          clusterIconPieChartRadius: 15,
          clusterIconPieChartCoreRadius: 10,
          clusterIconPieChartStrokeWidth: 3,
          openBalloonOnClick: true,
          clusterBalloonLeftColumnWidth: 120,
          balloonItemContentLayout: "cluster#balloonTwoColumnsItemContent"
        });

        map.geoObjects.add(this.objectManager);
      }

      if (!this.searchControl) {
        const provider = new CustomSearchProvider([this.objectManager]);

        this.searchControl = new ymaps.control.SearchControl({
          options: {
            provider: provider,
            noPlacemark: true,
            resultsPerPage: 5,
            placeholderContent: "Поиск по организациям"
          }
        });

        map.controls.remove("searchControl");
        map.controls.remove("typeSelector");
        map.controls.remove("rulerControl");
        map.controls.remove("trafficControl");
        map.controls.add(this.searchControl, { float: "right" });
      }
      if (this.points && this.points.length > 0) {
        this.objectManager.add(this.mapBalloon());
      }
    }
  },
  created() {
    this.getMapInfo(this.activeYear, this.regionId, this.guest);
  }
};
</script>

<style scoped>
</style>